import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Button, Icon, Modal } from '@weezevent/nacre';

export default function DeletionModal({ objectToDelete = null, onAccept, onClose, labelButton = null, icon = null, labelTitle = null, labelBody = null }) {
    const { t } = useTranslation();
    labelButton = labelButton || t('ticket.common.action.delete');
    labelTitle = labelTitle || t('ticket.modal.deleteTitle');
    labelBody = labelBody || t('ticket.modal.irreversible');

    if (!objectToDelete) {
        return null;
    }

    return (
        <Modal
            title={labelTitle}
            open={Boolean(objectToDelete)}
            onClose={onClose}
            submitButton={
                <Button
                    color="red"
                    labelPostion="left"
                    onClick={() => {
                        onAccept(objectToDelete);
                    }}
                >
                    <Icon name={icon} />
                    {labelButton}
                </Button>
            }
            cancelButton={<Button onClick={onClose}>{t(`ticket.common.action.cancel`)}</Button>}
        >
            {labelBody}
        </Modal>
    );
}

DeletionModal.propTypes = {
    objectToDelete: PropTypes.object,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    labelTitle: PropTypes.string,
    icon: PropTypes.string,
    labelButton: PropTypes.string,
    labelBody: PropTypes.string
};
